import React, { useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import "./styles/ExpSongCard.css";
import Chord from "../assets/Gmaj.png";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

function ExpSongCard(props) {
  const { checked, setChecked, setOpenSong, openSong } =
    useContext(MenuContext);

  // Add/Remove checked item from list
  const handleCheck = (selData) => {
    const array = [...checked];
    var removeIndex = array.map((i) => i.id).indexOf(props.selData.id);
    ~removeIndex && array.splice(removeIndex, 1);
    setChecked(array);
    console.log("Un-changed checked:", checked);
  };

  // Get the index of the song
  const indexArr = [...checked];
  const indexi = indexArr.findIndex((x) => x.id === props.selData.id);

  //   Logic to move up the song in "checked" songs list
  const moveUp = (array, index) => {
    if (index < 1 || index >= array.length) {
      // Can't move the 0th item or any item outside the bounds!
      return;
    }
    [array[index - 1], array[index]] = [array[index], array[index - 1]];
  };

  // Calling the function to actually move up
  const moveUpSong = () => {
    setTimeout(() => {
      moveUp(indexArr, indexi);
      setChecked(indexArr);
      console.log("Changed checked:", checked);
    }, 80);
  };

  const openTheSong = () => {
    const newSong = props.selData;
    const newSongArr = [...openSong, newSong];
    setOpenSong(newSongArr);
  };

  return (
    <div className="exp--card">
      <button onClick={moveUpSong} className="exp--up--icon">
        <ArrowDropUpIcon style={{ fill: "#121921" }} sx={{ fontSize: 50 }} />
      </button>
      <img className="exp--chord" src={Chord} />
      <div className="exp--body" onClick={openTheSong}>
        <h3 className="exp--title">{props.selData.title}</h3>
        <p className="exp--line--one">{props.selData.textLineOne}</p>
        <p className="exp--line--two">{props.selData.textLineTwo}</p>
        <p className="exp--line--one">{props.selData.textLineOne}</p>
      </div>
      <label className="exp--save">
        <input
          defaultChecked={true}
          // checked={defaultChecked}
          type="checkbox"
          className="exp--input"
          value={props.selData.id}
          onChange={handleCheck}
        />
        <span className="exp--icon">
          <BookmarkIcon sx={{ fontSize: 40 }} />
          {/* {props.checker === "done" ? (
            <BookmarkIcon sx={{ fontSize: 40 }} />
          ) : (
            <BookmarkBorderIcon sx={{ fontSize: 40 }} />
          )} */}
        </span>
      </label>
    </div>
  );
}

export default ExpSongCard;
